
import axios from 'axios';

import { getAuthToken } from '../utils/authUtils'; //

const API_BASE = process.env.REACT_APP_FIREBASE_BACKEND_API_BASE || 'https://quantumleap-emr-dev.web.app';
/**
 * Secure Facility Group Service
 * Uses backend API endpoints instead of direct Firestore access
 */

// Get all facility groups
export async function getFacilityGroups(options = {}) {
  try {
    const token = await getAuthToken();
    const response = await axios.get(`${API_BASE}/facility/facility-groups`, {
      params: options,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 200) {
      return response.data.map(group => ({
        ...group,
        facilities: Array.isArray(group.facilities) ? group.facilities : []
      }));
    }

    throw new Error('Failed to get facility groups');
  } catch (error) {
    console.error('Error getting facility groups:', error);
    throw error;
  }
}

// Get facility group by ID
export async function getFacilityGroupById(groupId) {
  try {
    const token = await getAuthToken();
    const response = await axios.get(`${API_BASE}/facility/facility-groups/${groupId}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 200) {
      return response.data;
    }

    throw new Error('Failed to get facility group');
  } catch (error) {
    console.error('Error getting facility group:', error);
    throw error;
  }
}

// Create a new facility group
export async function createFacilityGroup(groupData) {
  try {
    const token = await getAuthToken();
    const response = await axios.post(`${API_BASE}/facility/facility-groups`, groupData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 201) {
      return response.data;
    }

    throw new Error('Failed to create facility group');
  } catch (error) {
    console.error('Error creating facility group:', error);
    throw error;
  }
}

// Update an existing facility group
export async function updateFacilityGroup(groupId, updateData) {
  try {
    const token = await getAuthToken();
    const response = await axios.put(`${API_BASE}/facility/facility-groups/${groupId}`, updateData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 200) {
      return response.data;
    }

    throw new Error('Failed to update facility group');
  } catch (error) {
    console.error('Error updating facility group:', error);
    throw error;
  }
}

// Delete a facility group
export async function deleteFacilityGroup(groupId) {
  try {
    const token = await getAuthToken();
    const response = await axios.delete(`${API_BASE}/facility/facility-groups/${groupId}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 200) {
      return response.data;
    }

    throw new Error('Failed to delete facility group');
  } catch (error) {
    console.error('Error deleting facility group:', error);
    throw error;
  }
}

// Add facility to group
export async function addFacilityToGroup(groupId, facilityId) {
  try {
    const token = await getAuthToken();
    const response = await axios.post(`${API_BASE}/facility/facility-groups/${groupId}/facilities`, {
      facilityId
    }, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 200) {
      return response.data;
    }

    throw new Error('Failed to add facility to group');
  } catch (error) {
    console.error('Error adding facility to group:', error);
    throw error;
  }
}

// Remove facility from group
export async function removeFacilityFromGroup(groupId, facilityId) {
  try {
    const token = await getAuthToken();
    const response = await axios.delete(`${API_BASE}/facility/facility-groups/${groupId}/facilities/${facilityId}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 200) {
      return response.data;
    }

    throw new Error('Failed to remove facility from group');
  } catch (error) {
    console.error('Error removing facility from group:', error);
    throw error;
  }
}

// Get facilities in a group
export async function getFacilitiesInGroup(groupId, options = {}) {
  try {
    const token = await getAuthToken();
    const response = await axios.get(`${API_BASE}/facility/facility-groups/${groupId}/facilities`, {
      params: options,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 200) {
      return response.data;
    }

    throw new Error('Failed to get facilities in group');
  } catch (error) {
    console.error('Error getting facilities in group:', error);
    throw error;
  }
}

// Search facility groups
export async function searchFacilityGroups(searchTerm, options = {}) {
  try {
    const token = await getAuthToken();
    const response = await axios.get(`${API_BASE}/facility/facility-groups/search`, {
      params: { q: searchTerm, ...options },
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 200) {
      return response.data;
    }

    throw new Error('Failed to search facility groups');
  } catch (error) {
    console.error('Error searching facility groups:', error);
    throw error;
  }
}
